import { useStore } from "effector-react";
import React, { useEffect, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { GroupsSelect } from "../atoms/GroupsSelect";
import { queryDemGroups, $demandGroups, IDemGroup } from "../logics/demandGroups";
import { IQuerySetDemResult } from "../logics/types";
import { querySetDem } from "../logics/demands";
import { Trash } from "react-bootstrap-icons";
import { validatePhoneRU,removeValidateEmail, cutTextTwoParts, empty } from "../../../common/functions";
import { toast } from "react-toastify";
import { LTextarea } from "../../../common/ui/ltextarea";
import { LInput } from "../../../common/ui/linput";
import { getCustomUserAgent, getCustomUserAgentASB } from "../../../common/customUserAgent";
import { $contractorDems } from "../logics/contractorDemands";
import { $SiteColors } from "../../../common/config/company-atts";
import { getEmail, getPhone } from "../../../common/localStorage";
import { $user } from "../../../common/user";
import "../styles/validatinindEmail.css"

interface INewFreeDemand {
  companyId: number; //компания, по которому запрашиваем группы
  accountId: number; //аккаунт по которому создаем заявку
  setHideNewFreeDemWindow: React.Dispatch<React.SetStateAction<boolean>>; //переводим в true при отмене
  setHideDemDoneBlock: React.Dispatch<React.SetStateAction<boolean>>;
}

export const NewFreeDemand = ({ companyId = $SiteColors.getState().ComId, accountId = -1, setHideDemDoneBlock, setHideNewFreeDemWindow }: INewFreeDemand) => {
  const [selGroup, setSelGroup] = useState("");
  //@ts-ignore
  const [phone, setPhone] = useState(getPhone() || "");
  const [phoneNotValidated, setPhoneNotValidated] = useState(phone);
  
  const [email, setEmail] = useState(getEmail() || "");
  const [emailNotValidated, setEmailNotValidated] = useState(email);
  const [emailNotValid, setEmailNotValid] = useState(false);
  const [offSendBtn, setOffSendBtn] = useState(false);
  const [demText, setDemText] = useState("");
  //@ts-ignore
  const [files, setFiles] = useState<FileList>(null);
  const [attachFiles, setAttachFiles] = useState<File[]>([]);
  //@ts-ignore
  const [saveDemandResult, setSaveDemandResult] = useState<IQuerySetDemResult>({
    loaded: false,
    fail: false,
    msg: "",
    //@ts-ignore
    dem: null,
  });

  const { groups } = useStore($demandGroups);
  const [categories, setCategories] = useState([] as IDemGroup[])
  const newCategories = useStore($contractorDems)
  
  // useEffect(() => {
  //   console.log(newCategories)
  //   if (newCategories)//@ts-ignore
  //     setCategories(newCategories.services)
  // }, [newCategories])
  useEffect(() => {
    queryDemGroups({ accountId: accountId, companyId: companyId });
  }, [companyId, accountId]);
  useEffect(() => {
    setPhone(validatePhoneRU(phoneNotValidated).phone);
  }, [phoneNotValidated]);
  useEffect(() => {
    setEmail(emailNotValidated); // Добавить валидацию
    setEmailNotValid(removeValidateEmail(emailNotValidated))
  }, [emailNotValidated]);

  useEffect(() => {
    if (groups.length > 0 && selGroup === "") {
      setSelGroup(groups[0].id + "");
    }
  }, [groups]);

  const onBtnSetAttachesClicked = () => {
    let inp = document.getElementById("inp-load-files");
    //@ts-ignore
    inp.click();
  };
  //@ts-ignore
  const onSelectedFilesChanged = (e) => {
    let flist = e.target.files;
    if (flist.length > 0) setFiles(e.target.files);

    /////////----------------
    let newArr = attachFiles.slice(0) // [] as File[]
    if (flist.length > 0) {
      for (let i = 0, len = flist.length; i < len; ++i) {
        let file = flist.item(i) as File
        if (attachFiles.findIndex(f => f.lastModified == file.lastModified) == -1) newArr.push(file)
        //form.append("pictures[]", flist.item(i));
      }
      setAttachFiles(newArr/*prev => {
        console.log("PREV:", prev)
        prev.push(...newArr)
        console.log("NEXT:", prev)
        return prev
      }*/)
    }

  };

  const onCancelClicked = () => {
    setHideNewFreeDemWindow(true)
  }

  let flist = files == null ? [] : Array.from(files);

  const onSendDemClicked = () => {
    const res = validatePhoneRU(phone);
    if (!res.ok) {
      toast.error("Телефон должен быть в формате +7(ХХХ)ХХХ-ХХ-ХХ");
      return;
    }
    if(!emailNotValid){
      toast.error("Email должен быть в формате username@hostname.domain");
      return;
    }
    if (empty(selGroup)) {
      toast.error("Выберите категорию заявки");
      return;
    } else if (empty(companyId) || empty(demText)) {
      toast.error("Не заполнены все поля");
      return;
    }
    let form = new FormData();
    form.append("phone", phone);
    form.append("accountId", accountId == -1 ? "" : accountId + "");
    form.append("companyId",  $SiteColors.getState().ComId.toString());
    form.append("fio",  $user.getState().firstName+ "");
    form.append("demandGroupId", selGroup);
    form.append("initialText", demText);
    form.append("contractorDemandId", "601");
    attachFiles.forEach(f => form.append("pictures[]", f))
    /*if (files != null) {
      for (let i = 0, len = files.length; i < len; ++i) {
        //@ts-ignore
        form.append("pictures[]", files.item(i));
      }
    }*/
    setOffSendBtn(true)
    querySetDem(form, setSaveDemandResult);
  };

  const onDeleteFileClicked = (modified: number) => {
    setAttachFiles(attachFiles.filter(f => f.lastModified != modified))
  }

  useEffect(() => {
    if (saveDemandResult.loaded) {
      if (saveDemandResult.fail) {
        toast.error(saveDemandResult.msg);
        setOffSendBtn(false)
      } else {
        setHideNewFreeDemWindow(true)
        setHideDemDoneBlock(false)
        setOffSendBtn(false)
      }
    }
  }, [saveDemandResult]);

  return (
    <>
      <div className="omodal">
        <div className="omodal-content" style={{ background: "#F0F2F5", borderRadius: "12px" }} id="omodalContent">
          <button className="popup__close" type="button" onClick={onCancelClicked}>+</button>
          <div className="row col-12 d-flex m-auto pl-0 pr-0" style={{ paddingBottom: "24px" }}>
            <div
              style={{
                fontFamily: "SF Pro Display",
                fontWeight: "bold",
                fontSize: "16px",
                marginTop: "4px"
              }}
            >
              Создание заявки
            </div>
          </div>
          
          <GroupsSelect
            groups={groups}
            setSel={setSelGroup}
            sel={selGroup}
            disabled={false}
          ></GroupsSelect>


          <div style={{ marginBottom: "24px" }}>
            <LInput
              val={phone}
              setVal={setPhoneNotValidated}
              legendText={"Телефон"}
              placeholder={"Телефон"}
            />
          </div>
          {getCustomUserAgent() === getCustomUserAgentASB() ?
            <div style={{ marginBottom: "24px", display:"block" }}>
              <LInput
                val={email}
                validemail={emailNotValid}
                setVal={setEmailNotValidated}
                legendText={"Email"}
                placeholder={"Email"}
              />
              
            </div>
            : null}
          <div style={{ marginBottom: "24px" }}>
            <LTextarea
              val={demText}
              noLegend={false}
              legendText={"Текст заявки"}
              setVal={setDemText}
              placeholder="Что случилось? "
            />
          </div>
          <div className="text-center">
            <Button onClick={() => onSendDemClicked()} variant="default"
              disabled={offSendBtn}
              style={{
                background:$SiteColors.getState().backBtnSubmit,
                borderRadius: "12px",
                color: "white",
                paddingLeft: "120px",
                paddingRight: "120px",
              }}>{offSendBtn ? <Spinner animation="border" size="sm" /> : "Отправить"}</Button>
          </div>
          <Button disabled={offSendBtn} onClick={() => onBtnSetAttachesClicked()} variant="link" className="shadow-none" style={{ textDecoration: "underline", color: "black" }}>
            Прикрепить файлы
          </Button>
          <ul className="list-group" style={{ maxWidth: "400px" }}>
            {attachFiles.map((f, i) => (
              <li key={i} className="list-group-item pt-1 pb-1 d-flex">
                <span className="mt-auto mb-auto">{cutTextTwoParts(f.name)} </span>
                <Button onClick={() => onDeleteFileClicked(f.lastModified)} title="Удалить" variant="default" className="text-danger ml-auto mt-auto mb-auto" >
                  <Trash />
                </Button>
              </li>
            ))}
          </ul>
          <Form.File.Input id="inp-load-files" multiple hidden={true} onChange={(e: React.ChangeEvent) => onSelectedFilesChanged(e)}
          />
        </div>
      </div>
    </>
  );
};